export const FILE_SIZE = 10;

export const VALID_IMAGE_TYPE = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
};
